import { Link } from "react-router-dom";
import ".././styles/EventCard.css";

function EventCard({ image, title, date, description, link }) {
    return (

        <div className="event-card">
            <Link to={link}>
                <div className="event-img" style={{backgroundImage: `url(${image})`}}></div>
                <div className="event-details">
                    <h3 className="event-title">
                        {title}
                    </h3>
                    <p className="event-date">
                        {date}
                    </p>
                    <p className="event-description">
                        {description}
                    </p>
                </div>
            </Link>
        </div>
    );
}

export default EventCard;